export default __webpack_public_path__ + "static/media/error-icon.579abcb2.svg";